import axios from 'axios';
import type { AxiosResponse } from 'axios';

import type { HeatmapOnlyHighlightsListItem as HeatmapOnlyHighlightsListItemDto } from './dto';
import type {
  HeatmapOnlyHighlightsListItem as HeatmapOnlyHighlightsListItemModel,
  HeatmapHighlightCreateData as HighlightCreateDataModel,
} from './model';
import {
  mapHeatmapOnlyHighlightsDtoToModel,
  mapHeatmapHighlightCreateDataModelToDto,
} from './mapper';
import type { PaginatedResponse as PaginatedResponseModel } from '../common/model';
import type { PaginatedResponse as PaginatedResponseDto } from '../common/dto';
import { getPath } from '../common/api';
import type { SiteId } from '../common/api';

export interface CreateHighlightResponse {
  id: number;
}

export async function getHeatmapHighlights(
  siteId: SiteId,
  filters: Record<string, unknown>,
): Promise<PaginatedResponseModel<HeatmapOnlyHighlightsListItemModel>> {
  const path = `${getPath(siteId)}/heatmap/search?items_per_page=1000`;
  const response = await axios.post<PaginatedResponseDto<HeatmapOnlyHighlightsListItemDto>>(path, {
    filters,
  });

  return mapHeatmapOnlyHighlightsDtoToModel(response.data);
}

export async function createHeatmapHighlight(
  siteId: SiteId,
  highlightData: HighlightCreateDataModel,
): Promise<AxiosResponse<CreateHighlightResponse>> {
  const data = mapHeatmapHighlightCreateDataModelToDto(highlightData);

  const response = axios.post<CreateHighlightResponse>(`${getPath(siteId)}/heatmap`, data);

  return response;
}
